import { render, staticRenderFns } from "./Honour.vue?vue&type=template&id=1ddcdc96&scoped=true&"
import script from "./Honour.vue?vue&type=script&lang=js&"
export * from "./Honour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcdc96",
  null
  
)

export default component.exports